export default "__VITE_ASSET__p9YezwYR__"